import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import profileimg from "../../assets/profile.png";
import newsfeed from "../../assets/images/icons/newsfeed.png";
import friendsfollowers from "../../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../../assets/images/icons/groupandfamily.png";
import chats from "../../assets/images/icons/chats.png";
import notification from "../../assets/images/icons/notification.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useLocation } from "react-router-dom";
import { useSearch } from "../../context/SearchContext";

export default function Headmenu() {
  const location = useLocation();

  // User states for email and mobile login
  const [userEmail, setUserEmail] = useState(null);
  const [userMobile, setUserMobile] = useState(null);
  const [profilePictureUrl, setProfilePictureUrl] = useState(() => {
    return sessionStorage.getItem("profilePictureUrl") || profileimg; // Default to placeholder image
  });
    const [coverPictureUrl, setCoverPictureUrl] = useState("");

    useEffect(() => {
      const handleProfilePictureUpdate = () => {
        const updatedProfilePictureUrl = sessionStorage.getItem("profilePictureUrl");
        if (updatedProfilePictureUrl) {
          setProfilePictureUrl(updatedProfilePictureUrl);
        }
      };
  
      // Add a custom event listener for profile picture updates
      window.addEventListener("profilePictureUpdated", handleProfilePictureUpdate);
  
      // Reinitialize profilePictureUrl on component mount
      handleProfilePictureUpdate();
  
      // Cleanup the event listener
      return () => {
        window.removeEventListener("profilePictureUpdated", handleProfilePictureUpdate);
      };
    }, []);
  // Token states
  const [tokenEmail, setTokenEmail] = useState(null);
  const [tokenMobile, setTokenMobile] = useState(null);

  useEffect(() => {
    // Email login session
    const storedUser = sessionStorage.getItem("user");
    const storedToken = sessionStorage.getItem("accessToken");

    if (storedUser) {
      setUserEmail(JSON.parse(storedUser));
    }
    if (storedToken) {
      setTokenEmail(storedToken);
    }
  }, []);

  useEffect(() => {
    // Retrieve the uploaded profile picture URL from sessionStorage
    const storedProfilePictureUrl = sessionStorage.getItem("profilePictureUrl");
    if (storedProfilePictureUrl) {
      setProfilePictureUrl(storedProfilePictureUrl);
    }
  }, []);

  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = sessionStorage.getItem("accessToken");
  
      if (!token) {
        console.warn("Token not found");
        return;
      }
  
      try {
        const response = await fetch("https://pipaan.com360degree.com/api/user/profile", {
          method: "GET",
          headers: {
            "token": `${token}`,
            "Content-Type": "application/json",
          },
        });
  
        const data = await response.json();
  
        if (response.ok && data.result) {
          // Save profile picture URL to sessionStorage and state
          const profilePic = data.result.profile_picture_url;
          const coverPic = data.result.cover_picture_url;
  
          if (profilePic) {
            sessionStorage.setItem("profilePictureUrl", profilePic);
            setProfilePictureUrl(profilePic);
          }
  
          if (coverPic) {
            setCoverPictureUrl(coverPic);
          }
  
          // Optional: save other user details if needed
          setUserEmail(data.result);
        } else {
          console.error("Profile fetch error:", data.message);
        }
      } catch (err) {
        console.error("Network error fetching profile:", err);
      }
    };
  
    fetchUserProfile();
  }, []);
  // Search states
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [error, setError] = useState(null);

  // Function to perform API search
  const performSearch = async (query) => {
    if (query.length < 3) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    setError(null);

    try {
      const response = await fetch("https://pipaan.com360degree.com/api/user/get-all-users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": ` ${tokenEmail || tokenMobile}`, // If authentication is needed
        },
        body: JSON.stringify({
          filters: { username: query },
          page: 1,
          limit: 10,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSearchResults(data.data || []); // Assuming results are in `data.data`
      } else {
        setError(data.message || "Error fetching results");
      }
    } catch (err) {
      setError("Network error, please try again.");
    }

    setIsSearching(false);
  };

  // Handle search input changes
  const handleSearchChange = (e) => {
    const query = e.target.value;
    console.log("Typing:", query);
    setSearchQuery(query);
    performSearch(query);
  };

  const SearchFixedMenu = () => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
      const handleScroll = () => {
        setIsVisible(window.scrollY <= 100);
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);


   
    
    return (
      <div className="">
        <div className="flex justify-between items-center mb-6 w-full">
          <div className="flex relative w-full">
            <div className="fasearch">
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Search for people, communities or groups"
              className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300"
            />
            {searchQuery.length >= 3 && (
              <ul className="search-results absolute top-10 z-50 w-full bg-white shadow-lg rounded-lg mt-1 max-h-96 overflow-y-auto">
                {isSearching ? (
                  <li className="p-4 text-center">Searching...</li>
                ) : error ? (
                  <li className="p-4 text-center text-red-500">{error}</li>
                ) : searchResults.length > 0 ? (
                  searchResults.map((result) => (
                    <li key={result.id} className="hover:bg-gray-100">
                      <Link to={`/profile/${result.username}`} className="search-result-item flex items-center p-3">
                        <img
                          src={result.avatar || profileimg}
                          alt={result.first_name}
                          className="w-10 h-10 rounded-full mr-3"
                        />
                        <div>
                          <div className="font-medium">{result.first_name} {result.last_name}</div>
                          <div className="text-sm text-gray-500">@{result.username}</div>
                        </div>
                      </Link>
                    </li>
                  ))
                ) : (
                  <li className="p-4 text-center text-gray-500">No results found</li>
                )}
              </ul>
            )}
            <div className="relative top-2 hidden lg:block">
              <img src={notification} alt="Notifications" className="ml-4 cursor-pointer" />
            </div>
          </div>

          <div className="flex items-center hidden lg:block">
            <div className={`search-fixed-menu w-full p-4 pr-1 z-50 transition-all duration-300 ${isVisible ? "block" : "hidden"}`}>
              <div className="flex items-center">
                <div className="text-right pr-2 w-max">
                  {userEmail ? (
                    <>
                      <p>{userEmail.first_name || "No Name"}</p>
                      <p>{userEmail.email || "No Email"}</p>
                    </>
                  ) : userMobile ? (
                    <>
                      <p>{userMobile.first_name || "No Name"}</p>
                      <p>{userMobile.email || "No Phone"}</p>
                    </>
                  ) : (
                    <>
                      <p>Proveen Krishnamoorthy</p>
                      <p>@proveen_sky</p>
                    </>
                  )}
                </div>
                <div className="profile-dashboard rounded-full overflow-hidden">
                  {/* <img src={profilePictureUrl || profileimg} // Use uploaded profile picture or fallback */}
                  <img src={profilePictureUrl } // Use uploaded profile picture or fallback

                    alt="Profile" className="w-full h-full object-cover" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile-nav md:hidden mb-4 lg:hidden">
          <a
            href="/home"
            className={`aside-menu rounded-xl ${location.pathname === "/home" ? "active" : "hover:bg-gray-200"}`}
          >
            <img src={newsfeed} alt="News Feeds" />
            {location.pathname === "/home" && <span>News Feeds</span>}
          </a>

          <a
            href="/friendsfollowers"
            className={`aside-menu rounded-xl ${location.pathname === "/friendsfollowers" ? "active" : "hover:bg-gray-200"}`}
          >
            <img src={friendsfollowers} alt="Friends & Followers" />
            {location.pathname === "/friendsfollowers" && <span>Friends</span>}
          </a>

          <a
            href="/groupsfamily"
            className={`aside-menu rounded-xl ${location.pathname === "/groupsfamily" ? "active" : "hover:bg-gray-200"}`}
          >
            <img src={groupsandfamily} alt="Groups & Family" />
            {location.pathname === "/groupsfamily" && <span>Group</span>}
          </a>

          <a
            href="/"
            className={`aside-menu rounded-xl ${location.pathname === "/" ? "active" : "hover:bg-gray-200"}`}
          >
            <img src={chats} alt="Chats" />
            {location.pathname === "/" && <span>Chats</span>}
          </a>
        </div>
      </div>
    );
  };

  return <SearchFixedMenu />;
}
